import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { AppSettingsEffects } from './app-settings.effects';
import { categoryAppSettingsReducer } from './app-settings.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('category-application-settings', categoryAppSettingsReducer),
    EffectsModule.forFeature([AppSettingsEffects]),
  ],
  providers: [],
})
export class CategoryAppSettingsStoreModule {}
